import { intensityKindOf } from '~/domain/dicom/intensityUnits';
import type { Image3D } from '~/domain/patient/image3d';
import { CursorValue } from './types';

/**
 * A value sampled from `image`, read the way that image's modality is read.
 * A PET value carries the series' quantification with it, so the readout
 * can never fall back to a bare number for it.
 */
export function cursorValueFor(
    image: Pick<Image3D, 'seriesMetadata' | 'suvQuantification'>,
    value: number
): CursorValue {
    const kind = intensityKindOf(image.seriesMetadata.modality);
    return kind === 'pet'
        ? { value, kind, suvQuantification: image.suvQuantification ?? null }
        : { value, kind };
}
